import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import styles from './styles.m.scss'
import './styles.scss'
import ReactHtmlParser from 'react-html-parser'
import { FetchErrorMessage } from 'components/fetchErrorMessage'
import { LocaleContext } from '../../contexts/locale'
import { MunicipalitySearch } from '@ta-interaktiv/react-municipality-search'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { VoteBackendResponse } from 'types/voteBackendResponse'
import VotationResultsTable from 'components/votationResultsTable'
import clsx from 'clsx'
import Scrollchor from 'react-scrollchor'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Municipality } from 'types/municipalityChart'
// import DUMMYTEXTS from './de_main-run_1393572-2020-09-12.js'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import { ScrollToTopOnMount } from 'components/scrollToTop'
import LOCALES from './locales.js'
import csvjson from 'csvjson'

interface Props {
  municipalityId: string | null
  onMunicipalitySelection: (config: { GDENR: number }) => void
}

interface State {
  articleText: string | null
  texts: {
    federal: Array<string> | null
    cantonal: Array<string> | null
  }
  title: string
  errorMessage: string | null
  modules: Array<{ type: string; element: JSX.Element }>
}

export class Article extends React.Component<Props, State> {
  static contextType = LocaleContext

  state = {
    articleText: null,
    texts: { federal: [], cantonal: [] },
    title: LOCALES.title[this.context],
    errorMessage: null,
    communalVoteResults: null,
    modules: []
  }

  currentLocale = this.context

  /**
   * Send some data to the datapipeline
   *
   * @param  bfs Commune UID
   */
  static sendToDataPipeline = (bfs: string) => {
    const BASE_URL = 'https://w.tda.io/b/votation'
    const ZIP = '?zip=' + bfs
    const url = BASE_URL + ZIP
    return window
      .fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'include'
      })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  }


  /**
   * Retrieves processed communal vote results
   *
   * @param  bfs Commune UID
   * @param locale
   */
   getCommunalVoteResultText(bfs: string, locale: 'de' | 'fr') {
    const BASE_URL = 'https://atm.tamedia.ch'
    const API_ENDPOINT = '/api/vote/get_communal_results'
    const endpoint = new URL(API_ENDPOINT, BASE_URL)
    endpoint.searchParams.append('date', '20210926') // 20200927
    endpoint.searchParams.append('lang', locale)
    endpoint.searchParams.append('bfsid', bfs)
    endpoint.searchParams.append('format', 'text')
    const url = endpoint

    // noinspection JSIgnoredPromiseFromCall
    // Article.sendToDataPipeline(bfs)

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json() as Promise<VoteBackendResponse>
        }
        if (response.status == 404) {
          return new Promise(resolve => {
            resolve({ content: null })
        })}
        throw new Error(response.status + ': ' + response.statusText)
      })
  }

  /**
   * Retrieves processed texts from initial wordsmith templates
   *
   * @param  bfs Commune UID
   * @param locale
   */
  getVoteText(bfs: string, locale: 'de' | 'fr') {
    const BASE_URL = 'https://atm.tamedia.ch'
    const API_ENDPOINT = '/api/vote/get_raw_text'
    const endpoint = new URL(API_ENDPOINT, BASE_URL)
    endpoint.searchParams.append('date', '20210926') // 20200927
    endpoint.searchParams.append('lang', locale)
    endpoint.searchParams.append('bfsid', bfs)
    const url = endpoint

    // noinspection JSIgnoredPromiseFromCall
    // Article.sendToDataPipeline(bfs)

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json() as Promise<VoteBackendResponse>
        }

        // Dummy data

        /* const selectedDummyText =
          DUMMYTEXTS[+this.props.match.params.municipalityId - 1]
        return new Promise(resolve => {
          resolve({ content: selectedDummyText })
        }) as Promise<VoteBackendResponse> */

        //

        throw new Error(response.status + ': ' + response.statusText)
      })
  }

  handleError(error: Error) {
    this.setState({ errorMessage: error.message })
    console.group('Fetch Article')
    console.warn('Article could not be loaded')
    console.warn(error)
    console.groupEnd()
  }

  getVoteInfoDataCsv() {
    return fetch(
      `https://atm-vote.s3.amazonaws.com/chartdata_2021-09-26.csv`
    )
      .then(response => {
        return response.text()
      })
      .then(csv => {
        const csvData = csvjson.toObject(csv, {})
        const data = new Array<{ objectNumber: number; data: Municipality[] }>()
        const objects = new Array<{ objectNumber: number; key: string }>()

        Object.keys(csvData[0]).forEach(k => {
          const match = k.match(/(\d)_jastimmeninprozent/)
          if (match) {
            objects.push({
              objectNumber: +match[1],
              key: k
            })
          }
        })

        objects.forEach(o => {
          data.push({
            objectNumber: o.objectNumber,
            data: csvData.reduce((a, b) => {
              const res = +b[o.key]
              if (res) {
                return [
                  ...a,
                  {
                    canton: b.gdekt,
                    municipalityNumber: +b.bfs,
                    municipalityName: b[`gdename_${this.context}`],
                    result: +b[o.key]
                  }
                ]
              } else return a
            }, [])
          })
        })

        //

        data.forEach(o => {
          console.log(o.objectNumber)
          console.log(
            o.data.sort((a, b) =>
              a.result > b.result ? 1 : b.result > a.result ? -1 : 0
            )
          )
        })

        //

        return new Promise(resolve => {
          resolve(data)
        }) as Promise<{ objectNumber: number; data: Municipality[] }[]>
      })
      .catch(e => {
        console.log(e)
      })
  }

  /**
   * Find the title from the received text
   * @param text
   */
  extractTitle(text: string) {
    const titleRe = /<h4.*?>(.*?)(<br>|<\/h4>)/g
    const match = titleRe.exec(text)
    if (match && match[1]) {
      return match[1]
    } else {
      return LOCALES.title[this.context]
    }
  }

  /**
   * Clean up the received text
   * @param text
   */
  cleanText(text: string) {
    text = text.replace(/<br>((\s)*<br>)+/g, '<br><br>')
    text = text.replace(/^(<br>)+|(<br>)+$/g, '')
    // text = text.replace(/<\/h4>(\s)*(<br>)+/g, '</h4>')
    // Remove h4
    text = text.replace(/<h4.*?>(.*?)(<br>|<\/h4>(<br>)*)/g, '')
    //
    text = text.replace(/(.*?)<br>(<br>)+/g, '$1</p><p>')
    text = text.replace(/(<h4.*?<\/h4>)+/g, '$1<p>')
    text = '<p>' + text + '</p>'
    text = text.replace(/<\/p>+/g, '</p>')
    text = text.replace(/<p>(<h.*?>)/g, '$1')
    text = text.replace(
      '<!-- ballot --><br>',
      "<i class='ui envelope open icon object-sep'></i>"
    )
    text = text.replace(
      '<!-- participation --><br>',
      "<i class='ui percent icon object-sep'></i>"
    )
    text = text.replace(/(<\/h\d>)<\/p>/g, '$1')
    text = text.replace(/<p>\s*?<br>/, '<p>')
    console.log(text)

    return text
  }

  /**
   * Split the received text according to custom tags.
   * Also need the results to construct the chart module.
   * @param text
   * @param results
   */
  splitText(
    text: string,
    results: Array<{ objectNumber: number; data: Municipality[] }>
  ) {
    // Extract the results table
    const reTable = new RegExp(/{.*}/, 'gmi')
    const table = text.match(reTable)
    const rawText = text.replace(reTable, '')

    // Find the modules to add in the text
    const modulesMatchResult = rawText.match(/#MODULE:.*?#/gi)
    const modules = new Array<{ type: string; element: JSX.Element }>()

    // If there is modules tags in the text
    if (modulesMatchResult) {
      modulesMatchResult.forEach(t => {
        // Find the type of module
        const typeMatch = t.match(/#MODULE:(.*)?\(/)

        if (typeMatch) {
          const params = t.match(/\((.*?)\)/)
          let paramsList = new Array<string>()
          const type = typeMatch[1].toLowerCase()

          if (params) {
            paramsList = params[1].split(',')
            paramsList[0] = paramsList[0].toLowerCase()
          }

          const objectData = results.find(
            o => o.objectNumber === +paramsList[1]
          )
          // Add a new module according to the type
          switch (type) {
            case 'table':
              // If we don't have the data, then don't add the table
              if (table) {
                modules.push({
                  type: 'table',
                  element: (
                    <VotationResultsTable
                      chartData={objectData ? objectData.data : null}
                      municipalityNumber={this.props.municipalityId}
                      table={table[0]}
                      showOnly={paramsList}
                    />
                  )
                })
              }
              break
            case 'teasers':
              modules.push({
                type: 'teasers',
                element: (
                  <ArticleTeasers
                    className='mini-teasers'
                    numberOfCards='one'
                    articleIds={paramsList}
                  />
                )
              })
              break
          }
        }
      })
    }

    // Split the text into the same number of modules it contains
    // We want to show a module after each of these text sections
    const t = rawText.split('#CANTON#')
    let cantonalTexts = []
    const federalTexts = t[0].split(/#MODULE.*?#/) || []
    if (t.length > 1) {
      cantonalTexts = t[1].split(/#MODULE.*?#/)
      cantonalTexts.forEach((t, i) => (cantonalTexts[i] = this.cleanText(t)))
    }

    // Clean the text by replacing <br> by paragraphs and removing unnecessary breaklines
    federalTexts.forEach((t, i) => (federalTexts[i] = this.cleanText(t)))

    console.log(federalTexts, cantonalTexts, modules)

    return {
      texts: {
        federal: federalTexts,
        cantonal: cantonalTexts
      },
      modules: modules,
      rawText: rawText
    }
  }

  componentDidMount() {
    const backendRawText = this.getVoteText(
      this.props.municipalityId,
      this.context
    )
    const communalVoteResultText = this.getCommunalVoteResultText(
      this.props.municipalityId,
      this.context
    )
    const officialResults = this.getVoteInfoDataCsv()

    Promise.all([backendRawText, officialResults, communalVoteResultText])
      .then(data => {
        // Split the text according to its custom tags
        const splittedText = this.splitText(data[0].content, data[1])

        // Find the title
        const textTitle = this.extractTitle(data[0].content)

        // extract VoteResults
        const communalVoteResults = data[2].content

        this.setState({
          articleText: this.cleanText(splittedText.rawText),
          communalVoteResults: communalVoteResults,
          texts: splittedText.texts,
          modules: splittedText.modules,
          title: textTitle,
          errorMessage: null
        })
      })
      .catch(e => this.handleError(e))
    
  }


  componentDidUpdate(prevProps: Props): void {
    if (
      prevProps.municipalityId !== this.props.municipalityId ||
      this.currentLocale !== this.context
    ) {
      // make sure that we save the new locale
      this.currentLocale = this.context

      // Get new article text
      const backendRawText = this.getVoteText(
        this.props.municipalityId,
        this.context
      )
      const officialResults = this.getVoteInfoDataCsv()

      const communalVoteResultText = this.getCommunalVoteResultText(
        this.props.municipalityId,
        this.context
      )
      Promise.all([backendRawText, officialResults, communalVoteResultText])
        .then(data => {
          console.log(data[0].content, data[1])

          // Split the text according to its custom tags
          const splittedText = this.splitText(data[0].content, data[1])

          // Find the title
          const textTitle = this.extractTitle(data[0].content)

          // extract VoteResults
          const communalVoteResults = data[2].content

          this.setState({
            articleText: this.cleanText(splittedText.rawText),
            communalVoteResults: communalVoteResults,
            texts: splittedText.texts,
            title: textTitle,
            modules: splittedText.modules,
            errorMessage: null
          })
        })
        .catch(e => this.handleError(e))
    }
  }

  createDangerousHtmlObject(text: string) {
    return {__html: text}
  }

  render() {
    const containerClasses = 'step article'
    let textSliceIndex = 0

    const Search = (
      <aside className='ui secondary grey segment'>
        <h4 className='ui tiny header'>
          {LOCALES.municipalitySearchBoxTitle[this.context]}
        </h4>
        <MunicipalitySearch
          locale={this.context}
          dedupe={true}
          onSelectionHandler={this.props.onMunicipalitySelection}
        />
      </aside>
    )

    // Setup content for the default case
    let Content = (
      <div className='ui text container'>
        <div className={styles.railContainer}>
          {this.state.articleText && (
            <>
              {this.state.texts.cantonal.length > 1 &&
                this.state.texts.federal.length > 1 && (
                  <div className={clsx(styles.minimenu)}>
                    <div className='ui divider' />
                    <Scrollchor
                      to='#cantonal-votes'
                      beforeAnimate={() => {
                        // Analytics
                        window.dataLayer = window.dataLayer || []
                        window.dataLayer.push({
                          event: 'Interactions',
                          event_action: 'click',
                          event_label: `jump:cantons`
                        })
                      }}
                    >
                      {LOCALES.gotoCanton[this.context]}{' '}
                      <i className='ui icon chevron down' />
                    </Scrollchor>
                    <div className='ui divider' />
                  </div>
                )}
              {this.state.texts.federal && (
                <div id='federal-votes'>
                  {this.state.texts.federal.map((t, i) => {
                    if (i < this.state.texts.federal.length - 1)
                      textSliceIndex += 1

                    return (
                      <div
                        key={'federal-results-' + i}
                        className={`text-block ${this.state.modules[
                          textSliceIndex - 1
                        ] && this.state.modules[textSliceIndex - 1].type}`}
                      >
                        {ReactHtmlParser(t)}
                        {i < this.state.texts.federal.length - 1 &&
                          this.state.modules[textSliceIndex - 1].element}
                      </div>
                    )
                  })}
                </div>
              )}
              {this.state.texts.cantonal.length > 1 && (
                <>
                  {/* only show feedback prompt when federal texts are available */}
                  {this.state.texts.federal.length > 1 && (
                    <FeedbackMessage
                      locale={this.context}
                      mailTo='atm@tamedia.ch'
                    />
                  )}
                  <div id='cantonal-votes'>
                    {this.state.texts.cantonal.map((t, i) => {
                      if (i < this.state.texts.cantonal.length - 1)
                        textSliceIndex += 1

                      return (
                        <div
                          key={'cantonal-results-' + i}
                          className={`text-block ${this.state.modules[
                            textSliceIndex - 1
                          ] && this.state.modules[textSliceIndex - 1].type}`}
                        >
                          {ReactHtmlParser(t)}
                          {i < this.state.texts.cantonal.length - 1 &&
                            this.state.modules[textSliceIndex - 1].element}
                        </div>
                      )
                    })}
                  </div>
                </>
              )}
              {this.state.communalVoteResults != null && (
                <>
                  <h5>{LOCALES.communalVotesTitle[this.context]}</h5>
                  <div className={styles.railContainer}>
                      <p className='text-block' dangerouslySetInnerHTML={this.createDangerousHtmlObject(this.state.communalVoteResults)}>
                      </p>
                  </div>
                </>
              )}
            </>
          )}
          {!this.state.articleText && (
            <div className='ui placeholder'>
              <div className='header'>
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </div>
            </div>
          )}
          <aside
            className={`${clsx(styles.rail)} ${
              this.state.texts.cantonal.length <= 1 &&
              this.state.texts.federal.length <= 1
                ? clsx(styles.railMobile)
                : ''
            }`}
            style={{
              top: `${
                this.state.texts.cantonal.length > 1 &&
                this.state.texts.federal.length > 1
                  ? '8rem'
                  : 0
              }`
            }}
          >
            <a
              className={clsx(styles.dashboardLink)}
              href={`https://${LOCALES.dashboardPrefix[this.context]}.${
                parseHostname().publicationDomain
              }/`}
            >
              <img alt='' src={require('./votationHub.jpg')} />
              <div className={clsx(styles.dashboardLinkContent)}>
                <span className='abo'>Abo</span>
                <small>{LOCALES.votationLinkSup[this.context]}</small>
                <div>{LOCALES.votationLink[this.context]}</div>
              </div>
            </a>
          </aside>
        </div>
      </div>
    )

    // show something else in case of an error
    if (this.state.errorMessage) {
      Content = (
        <div className='ui text container'>
          <FetchErrorMessage
            status={this.state.errorMessage ?? ''}
            locale={this.context}
          />
        </div>
      )
    }

    return (
      <>
        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>{this.state.title}</h1>
              <h2>{LOCALES.lead[this.context]}</h2>
            </div>
          </div>
        </header>
        <ScrollToTopOnMount />
        <div
          className='ui vertical padded segment'
          // id='main-content'
          style={{ paddingBottom: 0 }}
        >
          <div className={containerClasses} style={{ zIndex: 10 }}>
            {Content}
            <div
              className='ui vertical colored padded segment'
              style={{ marginTop: '3rem' }}
            >
              <div className='ui text container'>{Search}</div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
